<template>
<div class="el-rate-runtime">
  <el-form-item :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : component.name" :class="{'hide-error':value,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}">
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
     <el-rate :ref="component.id + 'rata'" class="el-rate" @change="changeRate" v-model="currentValue" :disabled="component.properties.readonly" :texts="texts" :colors="colors"></el-rate>
  </el-form-item>
</div>
</template>

<script>
import { componentMixin, inputMixin } from './mixins'

export default {
  name: 'rc-rate',
  props: ['component', 'value', 'disabled'],
  mixins: [ componentMixin, inputMixin ],
  data () {
    let texts = []
    for (let key in this.component.properties.message) {
      texts.push(this.component.properties.message[key])
    }
    return {
      texts,
      colors: ['#55ACF1', '#55ACF1', '#55ACF1'],
      currentValue: parseInt(this.value)
    }
  },
  mounted () {
    this.$refs[this.component.id + 'rata'].$el.querySelectorAll('.el-rate__item').forEach((m, index) => {
      if (this.texts[index]) {
        m.setAttribute('data-title', this.texts[index])
      }
    })
    let themeColor = (this.$theme && this.$theme.themeColor) || document.documentElement.getAttribute('theme')
    if (themeColor) {
      let primaryColor = document.documentElement.style.getPropertyValue('--primary')
      this.colors = [primaryColor, primaryColor, primaryColor]
    }
  },
  methods: {
    changeRate (val) {
      this.update(val)
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    }
  },
  watch: {
    value (val) {
      this.currentValue = val ? parseInt(val) : 0
    }
  }
}
</script>
<style lang="scss">
.el-rate-runtime {
  .hide-error {
    .el-form-item__error {
      opacity: 0;
    }
  }
  .el-rate {
  margin-top: 5px;
  }
  span[data-title]{
    position: relative;
    display: inline-block;
  }
  span[data-title]:hover:after {
    content: attr(data-title);
    position: absolute;
    left: 50%;
    top: 26px;
    border-radius: 4px;
    padding: 10px;
    z-index: 2000;
    font-size: 12px;
    line-height: 1.2;
    min-width: 10px;
    background: #303133;
    color: #fff;
    transform: translateX(-50%);
    white-space: nowrap;
  }
  span[data-title]:hover:before {
    content: '';
    position: absolute;
    left: 50%;
    top: 20px;
    color: #fff;
    border-bottom:6px solid #303133;
    border-left:6px solid transparent;
    border-right:6px solid transparent;
    margin-left: -9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-rate.vue